export interface StoryProgressIndicator {
	index: number
	active: boolean
	condensed: boolean
}

const MAX_VISIBLE_INDICATORS = 7

export default function getStoryProgressIndicators(
	storyCount: number,
	storyIndex: number
): StoryProgressIndicator[] {
	const normalizedCount = Math.max(0, storyCount)
	const normalizedIndex = Math.min(Math.max(0, storyIndex), Math.max(0, normalizedCount - 1))
	const visibleCount = Math.min(normalizedCount, MAX_VISIBLE_INDICATORS)
	const maxStartIndex = Math.max(0, normalizedCount - visibleCount)
	const startIndex = Math.min(
		Math.max(0, normalizedIndex - Math.floor(visibleCount / 2)),
		maxStartIndex
	)
	const endIndex = startIndex + visibleCount

	return Array.from({ length: visibleCount }, (_, offset) => {
		const index = startIndex + offset

		return {
			index,
			active: index === normalizedIndex,
			condensed:
				(index === startIndex && startIndex > 0) ||
				(index === endIndex - 1 && endIndex < normalizedCount),
		}
	})
}
